import React from 'react';
import {suggestSharedTags} from '../../../firebase/firestore/sharedTags';
import RequirementTagsInput from './RequirementTagsInput';

/** Multiselect shared-tag field with autosuggest (gaps, FINTEL tagging, etc.). */
export default function SharedTagsInput(props) {
    return (
        <RequirementTagsInput
            suggestFn={suggestSharedTags}
            suggestLimit={30}
            {...props}
        />
    );
}
